// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"351":"00efb442","415":"a5adeac4"}[chunkId] + ".css";
};